<script>
export default {
	props: {
		success: {
			type: Boolean,
			default: false,
		},
		redirect: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			stepIsInvalid: false,
			submitButtonDisabled: false,
			otherErrors: {},
		};
	},
	methods: {
		async tryGotoStep(nextStep) {
			if (nextStep < this.step) {
				// when going back, do not validate input
				this.onStepValidContinue(nextStep);
				return;
			}
			let that = this;
			// validate the input fields visible in this step. if all ok, proceed to next step.
			this.form.post(this.$page.url, {
				preserveState: true,
				async onFinish(v) {
					if (that.getApiData) {
						await that.getApiData();
					}
					that.onStepValidContinue(nextStep);
					// remove pseudo price type after validation
					if (
						that.form.price &&
						that.form.price.type == "NONE" &&
						that.form.qty.mt !== null
					) {
						// check qty to make sure we are not in step 1
						that.form.price.type = "FLAT";
						that.priceTypeIsNone = true;
					}
				},
			});
		},
		async onStepValidContinue(nextStep) {
			// through the bus, ask all active input fields to report their validity. if we do not hear back, assume we are
			// clear for the next step!
			let stepHasError = false,
				fieldsMarkedInvalid = [];
			this.$bus.$off("is-mark-invalid");
			this.$bus.$on("is-mark-invalid", function (field, markInvalid) {
				if (markInvalid) {
					stepHasError = true;
					fieldsMarkedInvalid.push(field);
				}
			});
			this.$bus.$emit("poll-is-mark-invalid");
			this.$nextTick(function () {
				this.$bus.$off("is-mark-invalid");
				this.stepIsInvalid = stepHasError;

				// we may have errors in the form that do not belong to a specific field being displayed.
				// collect them in the otherErrors object
				this.otherErrors = Object.assign({}, this.form.errors);
				fieldsMarkedInvalid.forEach((f) => delete this.otherErrors[f]);

				if (stepHasError) {
					// scroll to top in case of error
					console.log("SCROLLING ONSTEPVALIDCONTINUE -- WINDOW");
					window.location.hash = "pageTop";
				}

				if (typeof nextStep == "function") {
					nextStep();
				} else {
					if (!stepHasError) {
						this.form.hasErrors = false;
						this.step = nextStep;
					}
				}
			});
		},
		async tryGotoStepIfFormValid(nextStep) {
			let that = this;
			this.tryGotoStep(function () {
				console.log("HERE", that);
				that.form.hasErrors = that.formIsInvalid;
				if (!that.formIsInvalid) {
					that.step = nextStep;
				}
			});
		},
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch", // always use patch for storing, even when creating
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onStart() {
					if (that.onStart) {
						that.onStart();
					}
				},
				onError(e) {
					that.submitButtonDisabled = false;
					that.onStepValidContinue(function () {});
					console.log("submit ERROR", method, endpoint, "got:", e);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);

					if (that.onFinish) {
						that.onFinish();
					} else if (that.redirect) {
						that.closeRedirect(that.redirect);
					} else if (that.success) {
						console.log("SUCCESS - closing modal");
						that.closeIframeModal();
					} else if (that.formIsInvalid) {
						window.location.hash = "pageTop";
					}
				},
				onSuccess() {
					if (that.onSuccess) {
						that.onSuccess();
					}
				},
			});
		},
		closeIframeModal() {
			if ("parentIFrame" in window) {
				parentIFrame.close();
			}
		},
		closeRedirect(url) {
			console.log("REDIRECT", url);
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage(["REDIRECT_TO", url]);
			} else {
				this.$inertia.visit(url);
			}
		},
	},
	computed: {
		formIsInvalid() {
			// at least one element in form.errors means the form is invalid
			return Object.keys(this.form.errors || {}).length > 0;
		},
	},
	created() {
		// convenience feature: add location#step2 to go directly to step 2!
		let m = window.location.hash.match("#step([0-9])");
		if (m) {
			this.step = 1 * m[1];
			this.tryGotoStep(this.step);
		}
	},
	mounted() {
		let that = this;

		// in case of iframe, signal to parent that we are mounted and ready to be displayed
		setTimeout(function () {
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage("READY_TO_RUMBLE");
			}

			if (that.redirect) {
				that.closeRedirect(that.redirect);
			}
		}, 300);
	},
};
</script>
